import { render, staticRenderFns } from "./AdvertisingSettings.vue?vue&type=template&id=0e9a5dd5&scoped=true&"
import script from "./AdvertisingSettings.vue?vue&type=script&lang=js&"
export * from "./AdvertisingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a5dd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
